import React, { useState, useEffect } from "react";
import placeholderImage from "../../assets/placeholder.webp";

const TableLazyImage = ({ src, alt, size = 10 }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (!src) {
      setHasError(true);
      return;
    }

    const img = new Image();
    img.src = src;
    img.onload = () => setIsLoaded(true);
    img.onerror = () => setHasError(true);
  }, [src]);

  if (hasError || !src) {
    return (
      <img
        src={placeholderImage}
        alt={alt}
        className={`w-${size} h-${size} rounded-full object-cover bg-gray-100 dark:bg-gray-700`}
      />
    );
  }

  return (
    <>
      <img
        src={isLoaded ? src : ""}
        alt={alt}
        className={`w-${size} h-${size} rounded-full object-cover bg-gray-100 dark:bg-gray-700 transition-opacity duration-200 ${
          isLoaded ? "opacity-100" : "opacity-0"
        }`}
        loading="lazy"
      />
      {!isLoaded && (
        <div
          className={`w-${size} h-${size} rounded-full bg-gray-200 dark:bg-gray-700 animate-pulse`}
        />
      )}
    </>
  );
};

export default TableLazyImage;
